"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingObserver = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const fs = require("fs");
class LoggingObserver {
    constructor(logFilePath) {
        this.logFilePath = logFilePath;
        this.log = [];
    }
    post(event) {
        this.writeLine(`${new Date().toLocaleString()} ${new Date().getMilliseconds()} ${event.eventName}`);
        const properties = event.getProperties();
        if (properties) {
            for (const property of Object.values(properties)) {
                this.writeLine(property);
            }
        }
        this.writeLine('');
    }
    innerDispose() {
        return fs.promises.writeFile(this.logFilePath, this.log.join('\n'));
    }
    dispose() {
        this.innerDispose().catch(() => { });
    }
    disposeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.innerDispose();
        });
    }
    getFileLocation() {
        return this.logFilePath;
    }
    writeLine(line) {
        this.log.push(line);
    }
}
exports.LoggingObserver = LoggingObserver;
//# sourceMappingURL=LoggingObserver.js.map